import styled from 'styled-components';

import { ActionButtonVariants } from 'components/action-button';

import * as Base from './base';

const StyledLink = styled(Base.StyledLink)`
  &.selected {
    color: ${Styles.color.navLinkColor.active};
  }

  &.selected:hover,
  &:hover {
    color: ${Styles.color.navLinkColor.hover};
  }
  &:hover::before,
  &.selected:hover::before {
    background-color: ${Styles.color.navLinkColor.hover};
  }
`;

export default {
  buttonVariant: ActionButtonVariants.INVERSE,
  linkVariant: ActionButtonVariants.PRIMARY
};

export * from './base';
export { StyledLink };
